import React from 'react';
import Modal from '../../../../../../../components/Modal';
import PropTypes from 'prop-types';
import QuestionThumbnail from './questionsThumbnail';
import studentClipboard from '../../../../../../../assets/images/studentClipboard.png';

const QuestionsClipboardModal = ({
  showQuestionsClipboardModal,
  setShowQuestionsClipboardModal,
  selectedQuestions,
  setSelectedQuestions,
  setDateBasedKey
}) => {
  return (
    <Modal
      isOpen={showQuestionsClipboardModal}
      onClose={() => setShowQuestionsClipboardModal(false)}
      titleName='Currently Selected Questions'
      contentWidth='60%'>
      {selectedQuestions.length <= 0 && <div className='d-flex flex-column align-items-center'>
        <div style={{
          backgroundImage: `url(${studentClipboard})`,
          backgroundRepeat: 'no-repeat',
          height: '100px',
          width: '160px',
          backgroundPositionX: 'center',
          marginBottom: '1em'
        }}>
        </div>
        <span>
          You currently do not have any questions selected.
        </span>
      </div>}

      {selectedQuestions.length > 0 && <div className='questionsGrid'>
        {selectedQuestions.map((question) => {
          return (<QuestionThumbnail key={`${question.questionSource}${question.questionId}`}
            questionDetails={question}
            defaultChecked={true}
            selectedQuestions={selectedQuestions}
            setSelectedQuestions={setSelectedQuestions}
            removeOnly={true}
            setDateBasedKey={setDateBasedKey}
          />);
        })}
      </div>}

    </Modal>
  );
};

QuestionsClipboardModal.propTypes = {
  showQuestionsClipboardModal: PropTypes.bool,
  setShowQuestionsClipboardModal: PropTypes.func,
  selectedQuestions: PropTypes.object,
  setSelectedQuestions: PropTypes.func,
  setDateBasedKey: PropTypes.func
};

export default QuestionsClipboardModal;
